import { Tab } from './Tab';
import { Tabs as Root } from './Tabs';

const Tabs = Object.assign(Root, { Tab });

export { Tabs };
